import Base from '../base.js';

export class View extends Base {
    constructor(containerId, options){
        options.mode = 2;
        super(containerId, options);
    }
}